import React from "react";
import { EpgDeliveryHistory } from "../epg-delivery-history-page.jsx";

export default function EpgDeliveryTab({ guid }) {
  return <EpgDeliveryHistory channelGuid={guid} />;
}
